import { checkoutInstance } from './axios';

export const getProducts = (): Promise<CheckoutProductData[]> => {
  return checkoutInstance.get('/product');
};

export const getProduct = (productId: string): Promise<CheckoutProductData> => {
  return checkoutInstance.get('/product/' + productId);
};

export const postOrder = (data: ApiOrderBody): Promise<ApiOrderResponse> => {
  return checkoutInstance.post('/order', data);
};

export const postPaypalOrder = (data: ApiPaypalOrderBody): Promise<any> => {
  return checkoutInstance.post('/paypal/order', data);
};

export const postPaypalCapture = (data: ApiPaypalCaptureBody): Promise<any> => {
  return checkoutInstance.post('/paypal/capture', data);
};

export const postPaypalSubscription = (data: ApiPaypalSubscriptionBody): Promise<any> => {
  return checkoutInstance.post('/paypal/subscription', data);
};

export const putPaypalSubscription = (data: ApiPutPaypalSubscriptionBody): Promise<any> => {
  return checkoutInstance.put('/paypal/subscription', data);
};

export const getProductPromotion = (productId: number, promotionCode: string): Promise<ApiProductIdPromotionCodeResponse> => {
  return checkoutInstance.get(`/product/${productId}/promotion/${promotionCode}`);
};

export const postImpUnsubscribe = (paymentId: string): Promise<any> => {
  return checkoutInstance.post(`/imp/unsubscribe`, {
    customer_uid: paymentId,
  });
};

export const postPaypalRefund = (paymentId: string): Promise<any> => {
  return checkoutInstance.post(`/paypal/refund`, {
    paymentId,
  });
};

export const postImpRefund = (paymentId: string): Promise<any> => {
  return checkoutInstance.post(`/imp/refund`, {
    imp_uid: paymentId,
  });
};

export const postPaypalUnsubscribe = (paymentId: string): Promise<any> => {
  return checkoutInstance.post(`/paypal/unsubscription`, {
    subscriptionId: paymentId,
  });
};

export const postImpFree = (params: ApiImpFreeBody): Promise<any> => {
  return checkoutInstance.post(`/imp/free`, params);
};

export const postPaypalFree = (params: ApiImpFreeBody): Promise<any> => {
  return checkoutInstance.post(`/paypal/free`, params);
};

export const postImpActivate = (data: ApiImpActivateBody): Promise<any> => {
  return checkoutInstance.post(`/imp/activate`, data);
};
